<template>
<div>
    <div class="mt-2">
        <v-btn text @click="$router.push(goTo)">
            <v-icon size="14px" color="grey darken-3" class="mr-3">fa-angle-left</v-icon>
                <span v-if="user.role.director">Back to schedules</span>
                <span v-if="user.role.master">Back to center</span>
        </v-btn>
    </div>

    <v-row>
        <v-col cols="12" sm="7">
            <v-card>
                <v-card-text v-if="loaded">
                    <div class="title accent--text">Create new schedule</div>

                    <div class="d-flex align-center mt-3">
                        <v-icon small class="mr-3">fa-store-alt</v-icon>
                        <div class="subtitle-1">{{center.name}} Center</div>
                    </div>

                    <div class="d-flex align-end mt-2">
                        <v-icon small class="mr-3 mb-1">fa-calendar-day</v-icon>
                        <v-text-field
                            v-model="model.day"
                            label="Day"
                            maxlength="40"
                            @keydown.enter="validate"
                            hide-details
                            autofocus>
                        </v-text-field>
                    </div>

                    <div class="d-flex align-end mt-4">
                        <v-icon small class="mr-3 mb-1">fa-hourglass</v-icon>
                        <v-text-field
                            v-model="model.hour"
                            label="Hour"
                            maxlength="40"
                            @keydown.enter="validate"
                            hide-details>
                        </v-text-field>
                    </div>

                    <div class="text-end mt-10">
                        <v-btn 
                            depressed 
                            class="accent" 
                            @click="validate" 
                            :disabled="sending">Add schedule</v-btn>
                    </div>
                </v-card-text>

                <SendingLoader v-else/>
            </v-card>
        </v-col>
    </v-row>
</div>
</template>

<script>
import Schedules from '@/firebase/schedules'
import Centers from '@/firebase/centers'

export default {
    data: () => ({
        loaded: false,
        sending: false,
        model: {
            day: '',
            hour: ''
        },
        centers: [],
        ct: null,
        center: null
    }),
    mounted() {
        this.getParams();
        this.getCenter();
    },
    computed: {
        goTo() {
            if (this.user.role.master) {
                return '/admin-center/'+this.ct;
            }
            if (this.user.role.director) {
                return '/admin-schedules';
            }
        }
    },
    methods: {
        getParams() {
            let url = new URL(window.location.href);
            this.ct = url.searchParams.get('ct');
        },
        getCenter() {
            Centers.get(this.ct)
                .then(response => {
                    if (response.status === true) {
                        this.center = response.doc.data();
                        this.loaded = true;
                    } else {
                        this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                    }
                })
        },
        validate() {
    		if (this.validateIsEmpty(this.model.day)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a day.'});
                return;
            }

            if (this.validateIsEmpty(this.model.hour)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set an hour.'});
                return;
            }

            this.add();
    	},
        add() {
            this.sending = true;

            Schedules.add(this.ct, this.model)
                    .then(response => {
                        if (response === true) {
                            if (this.user.role.director) {
                                this.$router.push('/admin-schedules');
                            } else {
                                this.$router.push('/admin-center/'+this.ct);
                            }
                            this.$store.dispatch('setSnack', {kind:'success', text:'A schedule has added.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>